import { tokens } from '../tokens';
function mediaQueryFromBreakpoint(breakpoint) {
    return "@media screen and (min-width: ".concat(breakpoint, ")");
}
export var mediaQuery = {
    aboveLarge: mediaQueryFromBreakpoint(tokens.breakpoints.large),
    aboveMedium: mediaQueryFromBreakpoint(tokens.breakpoints.medium),
    aboveSmall: mediaQueryFromBreakpoint(tokens.breakpoints.small),
};
